import React, { useEffect, useState } from 'react'
import ChatContainer from './Chat'
import Messenger from './Messenger'

const Chat = () => {

  const [activeChat, setActiveChat] = useState(null);
  const [resfreshChat, setResfreshChat] = useState(false);

  // console.log(activeChat, 'Active chat in Index')

  useEffect(() => {
    setResfreshChat(false);
  }, [resfreshChat])

  return (
    <div className='chat-layout-content'>
      <ChatContainer activeChat={activeChat} setActiveChat={setActiveChat} setResfreshChat={setResfreshChat} />
      <Messenger activeChat={activeChat} setActiveChat={setActiveChat} />
    </div>
  )
}

export default Chat